<template>
  <div>
    <div class="home" v-if="auth == 1">
      <div class="nav">
        <div class="nav_box">
          <div class="nav-title ai-tools">AI工具箱
          </div>
          <div class="nav_item"
               v-for="(item, index) in tools"
               :key="index"
               @click="selectTab(item.id)"
               :class="navIndex == item.id ? 'is-checked' : ''">
            <svg-icon :icon-class="item.icon" class="ver-middle  m-l-24 icon-logo"></svg-icon>
            <span class="nav_text">{{ item.name }}</span>
          </div>
        </div>
        <div class="user-logout" @click="logout">退出登录</div>
      </div>
      <div class="home_left">
        <template v-if="navIndex >= 10 ">
          <ai-chat v-if="navIndex == 11" :aiId="navIndex" logo="ai-progpt" title="ProGPT"></ai-chat>
          <ai-chat v-if="navIndex == 14" :aiId="navIndex" logo="ai-school" title="ProGPT"></ai-chat>
          <ai-chat v-if="navIndex == 12" :aiId="navIndex" logo="ai-recruit" title="ProGPT"></ai-chat>
          <ai-chat v-if="navIndex == 15" :aiId="navIndex" logo="ai-money" title="ProGPT"></ai-chat>
          <div v-if="navIndex == 13" class="plan-master">
            <plan-master ref="planMaster" :source="1"></plan-master>
          </div>
        </template>
      </div>
    </div>
    <div class="" v-else></div>
  </div>
</template>
<script>
import aiChat from './components/ai-chat'
import planMaster from './components/plan-master'
import {
  logout, getUser
} from "@/api/aiTool";

export default {
  name: 'Index',
  components: {
    aiChat,
    planMaster
  },
  data() {
    return {
      navIndex: 11,
      auth: '',
      userName: '',
      tools: [],
      uid: '',
    }
  },
  watch: {
    $route: {
      handler(nv, ov) {
      },
      deep: true,
      immediate: true,
    },
  },
  beforeCreate() {
  },
  created() {
    //鉴权
    let token = this.$route.query.token
    if (token) {
      localStorage.setItem('profly-sdpt-token', token)
      this.show()
    } else if (localStorage.getItem('profly-sdpt-token')) {
      this.show()
    } else {
      this.$router.push({path: '/login'})
    }


  },
  beforeDestroy() {
    //需要移除监听事件，不然会影响到其他页面
    window.removeEventListener('resize', this.handleResize)
  },
  beforeMount() {
  },
  destroyed() {
    document.documentElement.style['overflow-y'] = 'auto'
  },
  mounted() {
    document.documentElement.style['overflow-x'] = 'hidden'
    document.documentElement.style['overflow-y'] = 'hidden'
  },
  methods: {
    //tab 切换
    selectTab(id) {
      if (id == 14) {
        //window.open('https://ixz.szpu.edu.cn/aiChat/#/index')
        return '';
      }
      this.navIndex = id
    },
    getUserInfo() {
      getUser().then(res => {
        this.userName = res.data.name
        this.uid = res.data.uid
        this.tools = res.data.tools

      })
    },
    //退出
    logout() {
      logout().then(res => {
        localStorage.removeItem('profly-sdpt-token')
        window.location.href = "https://sdpt.profly.com.cn/#/login?q=logout"
      })
    },
    show() {
      this.getUserInfo()
      this.auth = 1
      this.handleResize()
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      let isMobile = window.matchMedia("(max-width: 525px)").matches;
      if (isMobile) {
        this.$router.push({path: '/m'})
      } else {
        this.$router.push({path: '/'})
      }
    }
  },
}
</script>
<style lang="less">

.h-menu_popover {
  padding: 0;
  border-radius: 6px;
  border: 0.5px solid #d6d8dc;
}

.user-more-opt {
  padding: 6px 0;
  min-width: 100px !important;
  border-radius: 10px;
  font-size: 13px;

  .item {
    height: 32px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: #f0f3f9;
    }
  }
}

.el-message {
  background: #fff;
  border-radius: 40px;
  border: 0.5px solid #E2E4E9;
  box-shadow: 0px -22px 33px rgba(145, 157, 165, 0.09), 0px 22px 33px rgba(145, 157, 165, 0.17);

  .el-message__content {
    font-weight: 400;
    color: #10141B;
  }

  .el-message__closeBtn {
    color: #10141B;
  }
}

.flex-1 {
  flex: 1;
}

.pointer {
  cursor: pointer;
}
</style>
<style lang="less" scoped>

.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-shrink: 0;

  .nav {
    width: 230px;
    border-right: 1px solid #eaeaea;
    min-width: 230px;
    height: 100vh;

    .is-checked {
      background-color: #f0f3f9;
    }

    .line {
      height: 1px;
      background-color: #e2e4e9;
      margin: 42px 24px 0 24px;
    }

    .nav_box {
      width: 100%;

      .nav-title {
        height: 50px;
        line-height: 50px;
        color: #10141B;
        font-size: 12px;
        font-weight: 550;
        padding-left: 24px;

      }

      .nav_item {
        height: 50px;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-bottom: 2px;

        .nav_text {
          font-weight: 400;
          font-size: 13px;
          color: #10141b;
          margin-left: 10px;
        }

        img {
          border-radius: 5px;
        }

        .icon-logo {
          width: 22px;
          height: 22px;
          border-radius: 4px;
          margin-left: 24px;
        }
      }

      .is-checked {
        background-color: #f0f3f9;
      }

      .nav_item:hover {
        background-color: #f0f3f9;
      }
    }

    .user-logout {
      position: absolute;
      bottom: 20px;
      width: 184px;
      height: 40px;
      border-radius: 10px;
      left: 23px;
      text-align: center;
      line-height: 40px;
      font-size: 13px;
      cursor: pointer;
      background: #F8F9FA;
      color: #787D86;
    }
  }

  .home_left {
    flex: 1;
    background-color: #F1F1F1;
  }
}

.plan-master {
  padding: 30px 30px 0 30px;
  height: 100vh;
  overflow: auto;
  box-sizing: border-box;
  background: #fff;
}
</style>
